import { Vue, Component, Watch } from 'vue-property-decorator'
import Axios from 'axios'

@Component
export default class DashboardPageComponent extends Vue {
  title: string = ''
  ruc: string = ''
  drawer: boolean = false
  dark: boolean = false;

  @Watch('dark')
  onToggleThemeMode (value:boolean, oldValue:boolean) {
    this.$vuetify.theme.dark = value
  }

  onLogOut () {
    sessionStorage.removeItem('token')
  }

  created () {
    this.getEnterprise()
  }

  getEnterprise () {
    const ruc = (document.head.querySelector('meta[name="ruc"]') as any).content
    Axios.get(`/enterprise/${ruc}`).then(response => {
      this.title = response.data.emi_nombre_comercial
      this.ruc = response.data.emi_ruc
    })
  }
}
